<template>
  <div>
    <v-card>
      <v-card-title>
        <div class="headline">
          {{
            formType === 'create' ? $t('whatsapp_create_template') : $t('whatsapp_update_template')
          }}
        </div>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text>
        <div class="caption error--text text-xs-right">
          * การส่ง Whatsapp Template จะมีค่าใช้จ่ายในการส่งข้อความ
        </div>
        <v-layout wrap class="pb-2">
          <v-flex xs12 sm6 form-control :class="{ 'has-error': errors.has('name') }" class="px-2">
            <input
              v-model="input.name"
              v-validate="{
                required: true,
                regex: /^[a-z0-9_\-]+$/
              }"
              type="text"
              class="form-control"
              :placeholder="$t('Name')"
              name="name"
              :data-vv-as="$t('Name')"
              aria-describedby="Name"
            />
            <span v-show="errors.has('name')" class="text-error">{{ errors.first('name') }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="px-2" style="display: flex" justify-end>
            <!-- <toggle-button
              :value="input.status"
              :sync="true"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              @change="handleChangeStatus"
            /> -->
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout wrap class="py-4">
          <v-flex xs12 sm12 class="px-2">
            <TemplateIntentGroup v-model="messages" :is-live-chat="isLiveChat" />
          </v-flex>
        </v-layout>
        <v-layout justify-center>
          <v-btn outline color="grey" @click="$emit('close')">{{ $t('cancel') }}</v-btn>
          <v-btn
            v-if="formType === 'edit_send'"
            depressed
            color="primary"
            @click="handleSubmitForm"
          >
            <em class="fas fa-paper-plane mr-2"></em>
            {{ $t('Send') }}
          </v-btn>
          <v-btn v-else depressed color="primary" @click="handleSubmitForm">{{ $t('Save') }}</v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import whatsappApi from '@/api/whatsapp.js'
import { mapGetters } from 'vuex'
import TemplateIntentGroup from './TemplateIntentGroup.vue'

export default {
  components: {
    TemplateIntentGroup
  },
  props: {
    formType: {
      type: String,
      default: 'create'
    },
    lang: {
      type: String,
      default: 'en'
    },
    item: {
      type: Object,
      default: () => {}
    },
    isLiveChat: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      input: {
        name: ''
      },
      messages: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    item: {
      deep: true,
      handler() {
        if (this.item) {
          this.initForm()
        }
      }
    }
  },
  mounted() {
    this.initForm()
  },
  methods: {
    initForm() {
      try {
        if (this.formType === 'edit' || this.formType === 'edit_send') {
          this.input.name = this.item.name
          const tempTemplateVal = JSON.parse(this.item.template_val)
          this.messages.push([...tempTemplateVal])
        } else {
          this.messages.push([])
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleChangeStatus() {},
    handleTransfromCustomWording() {
      const vm = this
      try {
        let result = {}
        const tempIntentItems = (vm.messages && vm.messages[0]) || []

        if (tempIntentItems.length > 0) {
          const findIntentText = tempIntentItems.find((item) => item.type === 'text') || {}

          const objCustomWording =
            (Object.keys(findIntentText).length > 0 && findIntentText.example) || {}

          if (Object.keys(objCustomWording).length > 0) {
            result = {
              example: {
                ...objCustomWording
              }
            }
          }
        }

        return result
      } catch (error) {
        console.error(error)
      }
    },

    async handleSubmitForm() {
      const vm = this
      try {
        const result = await vm.$validator.validateAll()

        if (!result) {
          vm.goToErrorInput()
          return false
        }

        const resultConfirm = await vm.$swal.fire({
          title: vm.$t('confirm_submit'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })

        if (resultConfirm.value) {
          let response = null

          vm.$store.dispatch('loading')
          const data = {
            page_id: vm.selectedBot.pageid,
            name: vm.input.name.trim(),
            lang: vm.lang,
            template: vm.messages[0],
            category: 'UTILITY'
          }

          if (vm.formType === 'create') {
            response = await vm.createWhatsappTemplate(data)
          } else if (vm.formType === 'edit_send') {
            const { template_id, lang } = vm.item
            const customWording = vm.handleTransfromCustomWording()
            const payload = {
              page_id: vm.$store.state.livechat.pageid,
              userid: vm.$store.state.livechat.currentUser.userid,
              template_id,
              lang,
              ...customWording
            }

            vm.$emit('sendToLivechat', payload)
          } else {
            response = await vm.updateWhatsappTemplate({
              id: vm.item.template_id,
              data
            })
          }
          vm.$store.commit('CLEAR_LOADING')

          if (response && response.status === 200) {
            const title =
              vm.formType === 'create'
                ? vm.$t('whatsapp_create_template_success')
                : vm.$t('whatsapp_update_template_success')

            vm.$swal.fire({
              title,
              type: 'success'
            })
            vm.$emit('close')
            vm.$emit('onRefetchData')
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.commit('CLEAR_LOADING')
      }
    },
    async createWhatsappTemplate(payload) {
      try {
        const response = await whatsappApi.postCreateWhatsappTemplate({ data: payload })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async updateWhatsappTemplate(payload) {
      try {
        const response = await whatsappApi.putUpdateWhatsappTemplate(payload)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async sendWhatsappTemplate(payload) {
      try {
        const response = await whatsappApi.postSendWhatsappTemplate({ data: payload })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/whatsapp/TemplateManagement/TemplateManageForm.vue